import React, { useState, useEffect } from 'react';
import List from './List'

const url = 'https://api.github.com/users';


const UseEffectFetchData = () => 
{
  const [users, setUsers] = useState([]);

  const getUsers = async () => 
  {
    const response = await fetch(url);
    const users = await response.json();
    setUsers(users);
    // console.log(users);
  };

  useEffect(() => 
  {
    getUsers();
  }, []);
  return (
    <>
      <h3>github users</h3>
      <ul className='users'>
        {
          users.map((user)=>
          {
            return <List key = {user.id} {...user} />
          })
        }
      </ul>
    </>
  );
};

export default UseEffectFetchData;